import { Link } from "react-router-dom";
import { useScrollAnimation, useStaggerAnimation } from "@/hooks/useScrollAnimation";
import { newsItems, categoryColors } from "@/mocks/news";

export default function JournalSection() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: cardsRef, visibleItems } = useStaggerAnimation(3, { threshold: 0.1 });

  return (
    <section id="journal" className="py-20 bg-[#f7fcfd]">
      <div className="max-w-[1240px] mx-auto px-6">
        {/* Title */}
        <div
          className="flex items-end justify-between mb-10"
          ref={titleRef as React.RefObject<HTMLDivElement>}
        >
          <div
            style={{
              opacity: titleVisible ? 1 : 0,
              transform: titleVisible ? "translateY(0)" : "translateY(25px)",
              transition: "opacity 0.7s ease, transform 0.7s ease",
            }}
          >
            <h2 className="text-3xl font-bold text-gray-800 font-['Poppins'] tracking-widest">
              NEWS
            </h2>
            <p className="text-sm text-gray-500 mt-1">最新のお知らせ</p>
          </div>
          <Link
            to="/news"
            className="text-[#3ab5c6] text-sm border border-[#3ab5c6] px-5 py-2 rounded-full hover:bg-[#3ab5c6] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            style={{
              opacity: titleVisible ? 1 : 0,
              transform: titleVisible ? "translateY(0)" : "translateY(25px)",
              transition: "opacity 0.7s ease 0.2s, transform 0.7s ease 0.2s",
            }}
          >
            一覧ページへ
          </Link>
        </div>

        {/* Cards */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          ref={cardsRef as React.RefObject<HTMLDivElement>}
        >
          {newsItems.map((item, i) => (
            <Link
              key={i}
              to="/news"
              className="bg-white rounded-2xl overflow-hidden cursor-pointer group"
              style={{
                opacity: visibleItems[i] ? 1 : 0,
                transform: visibleItems[i] ? "translateY(0)" : "translateY(35px)",
                transition: `opacity 0.7s ease, transform 0.7s ease`,
              }}
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700 ease-out"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className={`text-xs border px-2 py-0.5 rounded-full whitespace-nowrap ${categoryColors[item.category] ?? "text-gray-500 border-gray-300"}`}>
                    {item.category}
                  </span>
                  <span className="text-xs text-gray-400 font-['Poppins']">{item.date}</span>
                </div>
                <h3 className="text-sm font-bold text-gray-800 leading-snug mb-2 line-clamp-2 group-hover:text-[#3ab5c6] transition-colors duration-300">
                  {item.title}
                </h3>
                <p className="text-xs text-gray-500 leading-relaxed line-clamp-3">{item.excerpt}</p>
              </div>
              <div className="h-0.5 w-0 bg-[#3ab5c6] group-hover:w-full transition-all duration-500 ease-out"></div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
